import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5c92e1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "handle" }

import { IonIcon, IonModal } from "@ionic/vue";
import { close } from "ionicons/icons";


export default /*#__PURE__*/_defineComponent({
  __name: 'IonModalNoScrollContent',
  props: {
    modalElement: {},
    disableScroll: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any) {

const props = __props;





const handleMove = (event: Event) => {
    if (props.disableScroll) {
        event.stopPropagation();
    }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "close-button w-5 h-5 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_unref(IonIcon), {
          class: "black-icon close-icon",
          icon: _unref(close)
        }, null, 8, ["icon"])
      ])
    ]),
    _createElementVNode("div", {
      class: "h-full",
      onTouchmovePassive: handleMove,
      onPointermovePassive: handleMove,
      onMousemovePassive: handleMove
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 32)
  ], 64))
}
}

})